var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIlThumbnailImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 56,
    viewBox: "0 0 100 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 56,
    rx: 6,
    fill: "#77DDE3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 55,
    rx: 5.5,
    stroke: "#2A2A2A",
    strokeOpacity: 0.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.1887,
    y: 16,
    width: 24,
    height: 24,
    rx: 4,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8537 30.1723L58.2067 37.3746C57.9775 37.4557 57.7292 37.5 57.4721 37.5H42.9054C42.647 37.5 42.3987 37.4557 42.1682 37.3746L49.5237 30.1711L49.6301 30.0824C49.8118 29.9503 50.0344 29.8869 50.2584 29.9034C50.4824 29.9198 50.6933 30.0151 50.8537 30.1723ZM42.9054 18.5H57.4721C58.0599 18.5 58.6238 18.7335 59.0395 19.1492C59.4552 19.565 59.6887 20.1288 59.6887 20.7167V35.2833C59.6887 35.5481 59.6419 35.8014 59.557 36.037L52.1825 28.8145L52.0203 28.6675C51.4782 28.2128 50.7864 27.976 50.0793 28.0031C49.3723 28.0303 48.7006 28.3195 48.195 28.8145L40.8192 36.0357C40.7343 35.8001 40.6887 35.5468 40.6887 35.2833V20.7167C40.6887 20.1288 40.9223 19.565 41.338 19.1492C41.7537 18.7335 42.3175 18.5 42.9054 18.5ZM56.325 21.8688C55.79 21.3339 55.0645 21.0333 54.3079 21.0333C53.5514 21.0333 52.8258 21.3339 52.2909 21.8688C51.7559 22.4038 51.4554 23.1293 51.4554 23.8859C51.4554 24.6424 51.7559 25.368 52.2909 25.9029C52.8258 26.4379 53.5514 26.7384 54.3079 26.7384C55.0645 26.7384 55.79 26.4379 56.325 25.9029C56.8599 25.368 57.1605 24.6424 57.1605 23.8859C57.1605 23.1293 56.8599 22.4038 56.325 21.8688ZM53.6344 23.2123C53.813 23.0337 54.0553 22.9333 54.3079 22.9333C54.5605 22.9333 54.8028 23.0337 54.9815 23.2123C55.1601 23.391 55.2605 23.6332 55.2605 23.8859C55.2605 24.1385 55.1601 24.3808 54.9815 24.5594C54.8028 24.738 54.5605 24.8384 54.3079 24.8384C54.0553 24.8384 53.813 24.738 53.6344 24.5594C53.4557 24.3808 53.3554 24.1385 53.3554 23.8859C53.3554 23.6332 53.4557 23.391 53.6344 23.2123Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlThumbnailImage);
export default __webpack_public_path__ + "static/media/il-thumbnail-image.965beb806717839c47672b942cb23597.svg";
export { ForwardRef as ReactComponent };